require('../formData');
const flashMessages = require('../flashMessages');
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
  options.headers = { 'Accept': 'application/json' };

  const currentComplete = options.complete;
  options.complete = (...args) => {
    let shouldContinue = true;

    if(typeof currentComplete === 'function') {
      shouldContinue = currentComplete(...args) !== false;
    }

    if(shouldContinue) {
      onAjaxComplete(...args);
    }
  };
});

function onAjaxComplete(data) {
  let json = getRequestData(data);

  if(json.isError === 1) {
    const message = getMessage(json);
    toastr.error(message);

    if (json.code === 422) {
      formErrors(json);
      resetLoaderAndButtonsInModal(json);
      $.loading('reset-all');
    }

    if (json.code === 500) {
      resetLoaderAndButtonsInModal(json);
      $.loading('reset-all');
    }

    if (json.trace) {
      console.error('PHP Error:', json.message);
      console.error('Trace:', json.trace);
    }
  }

  if(json.flash && json.flash.message) {
    const namespace = ('namespace' in json.flash) ? json.flash.namespace : null;
    flashMessages.showFlashMessage(json.flash.message, namespace);
  }
}

$(document).ajaxSend(function(ev, xhr, settings) {
  if (settings.type === 'POST') {
    const forms = $('form');

    forms.find('.has-error').removeClass('has-error');
    forms.find('.help-block').remove();
  }
});

function getMessage(json) {
  if (json) {
    if ('message' in json) {
      return json['message'];
    } else if ('msg' in json) {
      return json['msg'];
    } else if ('msgError' in json) {
      return json['msgError'];
    }
  }

  return 'Error';
}

function formErrors(data) {
  const form = data.formName ? $(`form[name="${data.formName}"]`): $('form');

  if (data.errors && data.errors.length !== 0) {
    $.each(data.errors, (elementId, value) => {
      $.each(value, (index, value) => {
        form.find(`[name="${elementId}"]`).parent().addClass('has-error');
        form.find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
      });
    });
  }
}

function resetLoaderAndButtonsInModal(data) {
  const form = data.formName ? $(`form[name="${data.formName}"]`): $('form');
  const modal = form.parents('.modal-content');

  if (modal.length > 0) {
    const footer = modal.find('.modal-footer');

    footer.find('button:not([disabled])').show();
    footer.find('img').hide();
  }
}

function getRequestData(data) {
  try {
    return JSON.parse(data.responseText);
  } catch (e) {
    return {};
  }
}
